import { createContext } from 'react';

export const NotificationCounterContext = createContext(null);
